import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppConstants } from "src/app/shared/constants/app.contants";
import { AuthenticationComponent } from "./components/authentication/authentication.component";
import { LoginComponent } from "./components/login/login.component";
import { ForgetEmailComponent } from "./components/forget-email/forget-email.component";
import { OtpComponent } from 'src/app/modules/authentication/components/otp/otp.component';
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { SuccessComponent } from "./components/success/success.component";
import { EmailVerificationComponent } from "./components/email-verification/email-verification.component";
import { MicrosoftCallbackComponent } from "./components/microsoft-callback/microsoft-callback.component";
import { GuestGuard } from "src/app/shared/guards/guest.guard";

export const routes: Routes = [
    {
        path: '',
        component: AuthenticationComponent,
        children: [
          { path: AppConstants.ROUTES.LOGIN, component: LoginComponent, canActivate: [GuestGuard] },

            {
                path: AppConstants.ROUTES.OTP_Page,
                component: OtpComponent
            },
            {
                path: AppConstants.ROUTES.FORGET_EMAIL,
                component: ForgetEmailComponent
              },
              {
                path: AppConstants.ROUTES.CHANGE_PASS,
                component: ChangePasswordComponent
              },
              {
                path: AppConstants.ROUTES.SUCCESS,
                component: SuccessComponent
              },
              {
                path: AppConstants.ROUTES.verifyEmail,
                component: EmailVerificationComponent
              },
              {
                path: AppConstants.ROUTES.MICROSOFT_CALLBACK,
                component: MicrosoftCallbackComponent
              },
              { path: '', pathMatch: 'full', redirectTo: AppConstants.ROUTES.LOGIN }

        ]
    }
]

export const AUTHENTICATION_ROUTES: ModuleWithProviders<any> = RouterModule.forChild(routes);
